(ns manage.adset-decision-tree-page.view.table.meta
  (:require ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Switch$default" :as Switch]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            [cljs-bean.core :refer [->js]]
            [common.queries :refer [use-mutation]]
            [common.resource.query.adset-activation
             :refer [update-activation-mutation]]
            [common.util :refer [->locale-string]]
            [common.widgets.data-grid :as dg]
            [manage.ad-variant.page.columns :as ad-variant-columns]
            [manage.adset-decision-tree-page.view.table-util :as tu]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn get-cell-value [path _value row ^js _column ^js _apiRef]
  (get-in row path))

(defui enabled-cell [{{:keys [enabled id orphan]} :value}]
  (let [{update-activation :mutate} (-> (use-subscribe [:url-context])
                                        (assoc :activation-id id)
                                        update-activation-mutation
                                        use-mutation)]
    ($ Tooltip
       {:title "Switch on to run this ad on Meta; switch off to pause it."
        :placement "top"}
       ($ Switch
          {:checked enabled
           :disabled orphan
           :onChange (fn [] (update-activation {:enabled (not enabled)}))
           :onClick #(.stopPropagation %)}))))

(defui live-now-cell [{live? :value}]
  ($ Icon {:sx #js {:fontWeight "bold"
                    :color (if live? "success.main" "grey.20")}}
     (if live? "checkmark" "remove")))

(def columns
  (->> [{:field "enabled"
         :headerName ""
         :width 70
         :minWidth 70
         :valueGetter (fn [_value row] (select-keys row [:orphan :enabled :id]))
         :renderCell (dg/get-cell-renderer enabled-cell)}
        tu/identifier-with-schedule-column
        tu/decision-path-column
        {:field "meta-ad-id"
         :sortable false
         :headerName "Meta Ad ID"
         :width 200
         :headerAlign "right"
         :align "right"
         :valueGetter (fn [_value row] (tu/get-ad-id "meta" row))}
        {:field "meta-adset-id"
         :sortable false
         :headerName "Meta Adset ID"
         :width 200
         :headerAlign "right"
         :align "right"
         :valueGetter (fn [_value row] (tu/get-ad-group-id "meta" row))}
        {:field "integration-feedback"
         :sortable false
         :headerName "Integration feedback"
         :width 200
         :valueGetter (fn [_value row] (get-in row [:integration-error :message]))}
        {:field "live-now"
         :headerName "Live Now"
         :width 100
         :valueGetter (partial get-cell-value [:live-now])
         :renderCell (dg/get-cell-renderer live-now-cell)}
        {:field "impressions"
         :filterable false
         :width 80
         :headerName "Impressions"
         :valueGetter (partial get-cell-value [:sync-data :insights 0 :impressions])
         :type "number"
         :renderCell (fn [^js params]
                       ($ Tooltip {:title "The value shows yesterday's impression totals, refreshed daily at 6 AM GMT"}
                          ($ Typography ((fnil ->locale-string 0) (.-value params)))))}
        (assoc tu/activation-status-column
               :valueGetter (fn [_ row]
                              (if (= "draft" (:approval row))
                                "draft"
                                (:activation-status row)))
               :renderCell tu/render-combined-status-cell)
        (assoc tu/targeting-preview-column :valueGetter
               (fn [_value row] #{(get-in row [:data :ad-variant-id])}))
        tu/navigate-to-node-column]

       ;; These columns are needed for filters
       (concat [{:field "template"}
                {:field "ad-variant-id"}
                {:field "freetext"}
                {:field (:field tu/integration-error-filter)}])
       ->js))

(def field->sort-field
  {"live-now" "live-now>"
   "enabled" "enabled"
   (.-field ad-variant-columns/identifier-column) "content-id>"
   (:field tu/activation-status-column) "activation-status>"
   "template" "template>"
   "impressions" "impressions>"})

(def field->resolver
  {"live-now" "live-now"
   "template" "template"
   (.-field ad-variant-columns/identifier-column) "content-id"
   (:field tu/activation-status-column) "activation-status"
   "freetext" "freetext"
   (:field tu/integration-error-filter) (:id tu/integration-error-filter)})

(def field->column
  {"live-now" "live-now"
   (.-field ad-variant-columns/identifier-column) "content-id"
   (:field tu/activation-status-column) "activation-status"
   "template" "template"
   (:field tu/integration-error-filter) "type"})

(def query-filter-params
  {:field->sort-field field->sort-field
   :field->resolver field->resolver
   :field->column field->column
   :quick-filter {:field "freetext"}})

(def additional-filters
  [{:label "Live Now"
    :field "live-now"
    :id "live-now"
    :multiple false
    :data-testid "liveNowFilterSelect"
    :filter-options [{:value "true"
                      :label "On"}
                     {:value "false"
                      :label "Off"}]}
   tu/integration-error-filter])

(defn get-row-id [row]
  (:id row))

(defn get-ad-variant-id [row] (get-in row [:data :ad-variant-id]))
